module.exports = {"340124100":"庐城镇","340124101":"冶父山镇","340124102":"万山镇","340124103":"汤池镇","340124104":"郭河镇","340124105":"金牛镇","340124106":"石头镇","340124107":"同大镇","340124108":"白山镇","340124109":"盛桥镇","340124110":"白湖镇","340124111":"龙桥镇","340124112":"矾山镇","340124113":"罗河镇","340124114":"泥河镇","340124115":"乐桥镇","340124116":"柯坦镇","340124400":"安徽庐江经济开发区","340124401":"白湖监狱生活社区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340124.json
// module id = 1145
// module chunks = 0